import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data?.company) {
            datas.company_code = data?.company
        }
        if (data?.customer) {
            datas.customer_code = data?.customer
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data.id) {
            datas.id = data.id
        }
    }
    return ApiService.get('/api/v1/meson-app/meson-wms-stock-holding-hdr/', datas)
}
export const createApiRecord = data => ApiService.filePost('/api/v1/meson-app/meson-wms-stock-holding-hdr/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/meson-app/meson-wms-stock-holding-hdr/${id}/`)
export const updateApiRecord = (id, data) => ApiService.filePut(`/api/v1/meson-app/meson-wms-stock-holding-hdr/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/meson-app/meson-wms-stock-holding-hdr/${id}/`)

export const getApiDetails = data => ApiService.get(`/api/v1/meson-app/meson-wms-stock-holding-dtl/`, data)
export const getApiBom = data => ApiService.get(`/api/v1/meson-app/meson-wms-stock-holding-bom/`, data)
export const getApiPack = data => ApiService.get(`/api/v1/meson-app/meson-wms-stock-holding-pack/`, data)
export const getApiItem = data => ApiService.get(`/api/v1/meson-app/meson-wms-stock-holding-item/`, data)
